module.exports = __webpack_public_path__ + "static/media/project12.176dabfd.png";